import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { InvoiceStatus } from "@/lib/constants/invoiceStatus";
import { useUpdateInvoice } from "@/queries/invoices/update";
import { useTranslation } from "react-i18next";

type Props = {
  invoiceId: string;
};

export const AiProcessingCard = ({ invoiceId }: Props) => {
  const { t } = useTranslation();
  const [updateInvoice] = useUpdateInvoice();

  const handleManualProcessing = async () => {
    await updateInvoice({
      invoiceId,
      manualProcessing: true,
      status: InvoiceStatus.PREPROCESSED,
    });
  };

  return (
    <Card className="w-full mt-4">
      <CardHeader>
        <CardTitle>{t("ai_processing.title")}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <p>{t("ai_processing.description")}</p>
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={handleManualProcessing}
            className="w-fit"
          >
            {t("ai_processing.skip_button")}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
